import './ShareReport.scss';
import React from 'react';
import { FormikProps } from 'formik';
import { IonCheckbox, IonItem, IonLabel, IonRow } from '@ionic/react';
import { useIntl } from 'react-intl';
import { JobMessages } from '../../intl/JobMessages';
import { Organization } from 'src/models/organization';
import { InputSelect } from '../reusable-components/InputSelect';

export interface FamilyOrgShareFormData {
  tubes: boolean;
  annotations: boolean;
  timestamps: boolean;
  pressure: boolean;
  pieCharts: boolean;
  idleVsPressure: boolean;
  configurations: boolean;
  organization: string;
}

interface FamilyOrgShareFormProps {
  /**
   * The users organizations
   */
  organizations: Organization[];
  /**
   * State, handlers, and helpers made available to form component or render prop of.
   */
  formikProps: FormikProps<FamilyOrgShareFormData>;
  /** The label to apply to the organization select form field */
  organizationLabel: string;
}

export const FamilyOrgShareForm: React.FC<FamilyOrgShareFormProps> = ({
  organizations,
  formikProps,
  organizationLabel,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <IonRow className="ion-padding-vertical">
        <IonLabel>{formatMessage(JobMessages.selectInformationToShare)}</IonLabel>
      </IonRow>
      <IonRow className="ion-padding-vertical">
        <IonLabel>{formatMessage(JobMessages.chartsAndGraphs)}</IonLabel>
      </IonRow>
      <IonItem className="tubes-checkbox-item">
        <IonCheckbox
          className="tubes-checkbox"
          checked={formikProps.values.tubes}
          onIonChange={() => formikProps.setFieldValue('tubes', !formikProps.values.tubes)}
          slot="start"
        />
        <IonLabel>{formatMessage(JobMessages.tubes)}</IonLabel>
      </IonItem>
      <IonItem className="tubes-checkbox-item">
        <IonCheckbox
          className="tubes-checkbox"
          checked={formikProps.values.annotations}
          onIonChange={() => formikProps.setFieldValue('annotations', !formikProps.values.annotations)}
          slot="start"
        />
        <IonLabel>{formatMessage(JobMessages.annotations)}</IonLabel>
      </IonItem>
      <IonItem className="tubes-checkbox-item ">
        <IonCheckbox
          className="tubes-checkbox"
          checked={formikProps.values.pressure}
          onIonChange={() => formikProps.setFieldValue('pressure', !formikProps.values.pressure)}
          slot="start"
        />
        <IonLabel>{formatMessage(JobMessages.pressure)}</IonLabel>
      </IonItem>
      <IonItem className="tubes-checkbox-item">
        <IonCheckbox
          className="tubes-checkbox"
          checked={formikProps.values.pieCharts}
          onIonChange={() => formikProps.setFieldValue('pieCharts', !formikProps.values.pieCharts)}
          slot="start"
        />
        <IonLabel>{formatMessage(JobMessages.pieCharts)}</IonLabel>
      </IonItem>
      <IonItem className="tubes-checkbox-item ">
        <IonCheckbox
          className="tubes-checkbox"
          checked={formikProps.values.idleVsPressure}
          onIonChange={() => formikProps.setFieldValue('idleVsPressure', !formikProps.values.idleVsPressure)}
          slot="start"
        />
        <IonLabel>{formatMessage(JobMessages.idleVsPressure)}</IonLabel>
      </IonItem>
      <IonItem className="tubes-checkbox-item ion-margin-bottom">
        <IonCheckbox
          className="tubes-checkbox"
          checked={formikProps.values.configurations}
          onIonChange={() => formikProps.setFieldValue('configurations', !formikProps.values.configurations)}
          slot="start"
        />
        <IonLabel>{formatMessage(JobMessages.configuration)}</IonLabel>
      </IonItem>

      <IonRow className="ion-padding-vertical">
        <IonLabel>{formatMessage(JobMessages.additionalSettings)}</IonLabel>
      </IonRow>
      <IonItem className="tubes-checkbox-item">
        <IonCheckbox
          className="tubes-checkbox"
          checked={formikProps.values.timestamps}
          onIonChange={() => formikProps.setFieldValue('timestamps', !formikProps.values.timestamps)}
          slot="start"
        />
        <IonLabel>{formatMessage(JobMessages.timeStamps)}</IonLabel>
      </IonItem>
      <InputSelect
        label={organizationLabel}
        value={formikProps.values.organization}
        onChange={e => formikProps.setFieldValue('organization', e)}
        onBlur={formikProps.handleBlur}
        placeholder={formatMessage(JobMessages.organization)}
        options={organizations.map(org => ({ label: org.orgName, value: org._id }))}
        name="organization"
        id="share-report-select-organization"
        required
        // no error text, submit button is disabled if no organization is selected
      />
    </>
  );
};
